// ค่าที่ต่างกันระหว่างเครื่อง dev กับ production ตั้งใน .env.local / .env.production
export const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3002';
export const THAID_REDIRECT_URI = process.env.VUE_APP_THAID_REDIRECT_URI || 'http://localhost:8081/callback/thaid';
